import { matchRoutes, useLocation } from 'react-router'
import { getPagesForMatching } from '../routing/pages'

// Get path template of route, that matches current location
export function useRouteMatch(): string {
  const location = useLocation()
  const matchedPage = matchRoutes(getPagesForMatching(), location)
  const pathTmpl = matchedPage?.length ? matchedPage[0].route.path : null

  if (!pathTmpl) {
    throw Error('Can not match any route with given location')
  }

  return pathTmpl
}
